/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { IUpdateCollaboratorPayload, ICollaboratorEntity, ICollaboratorListResponse, ICreateCollaboratorPayload, IListCollaboratorsPayload, ICollaboratorsListPayload } from "./collaborators.interface";
import { ICubageEntity } from "../cubages/cubages.interface";
import { Environment } from "../../../Config/constants";

export class CollaboratorsApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public changePassword = async (newPassword:string): Promise<Result<void>> => {
    try {
     
        const response = await this.service.post(`/me/reset-password`, { newPassword });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public destroy = async (collaboratorId:string): Promise<Result<void>> => {
    try {
     
        const response = await this.service.delete(`/collaborators/${collaboratorId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async ({ id, ...rest}: IUpdateCollaboratorPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/collaborators/${id}`, { ...rest });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreateCollaboratorPayload): Promise<Result<ICollaboratorEntity>> => {
    try {
        const response = await this.service.post(`/collaborators`, data);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async ({ page, searchBy }: ICollaboratorsListPayload): Promise<Result<ICollaboratorListResponse>> => {
    try {
        const response = await this.service.get(`/collaborators`, { 
            params: {
              offset: Number(Environment.OFFSET_REGISTERS),
              page,
              searchBy
            }
        });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (collaboratorId: string): Promise<Result<ICollaboratorEntity>> => {
    try {
        const response = await this.service.get(`/collaborators/${collaboratorId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
